require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/object/keys.js
// module id = 1285
// module chunks = 0